import type { AppRouteRecordRaw } from '@/router/types'
import { useI18n } from '@/hooks/web/useI18n'
import { LAYOUT } from '@/router/constant'

const { t } = useI18n()
const UserManagerRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'UserManagement',
  component: LAYOUT,
  meta: {
    title: t('router.userManagement'),
    icon: 'home'
  },
  children: [
    {
      path: '/accountManagement',
      name: 'AccountManagement',
      component: () => import('@/views/userManagement/userMgrList.vue'),
      meta: {
        title: t('userManagement.accountManage'),
        icon: 'card'
      }
    },
    {
      path: '/addOrEditRole',
      name: 'AddOrEditRole',
      component: () => import('@/views/userManagement/addOrEditRole.vue'),
      meta: {
        title: t('userManagement.addRole'),
        hideBreadcrumb: true,
        hideMenu: true
      }
    },
    {
      path: '/addOrEditUser',
      name: 'AddOrEditUer',
      component: () => import('@/views/userManagement/addOrEditUser.vue'),
      meta: {
        title: t('userManagement.userInfo'),
        hideBreadcrumb: true,
        hideMenu: true
      }
    },

    {
      path: '/updateSelfPwd',
      name: 'UpdateSelfPwd',
      component: () => import('@/views/userManagement/updateSelfPwd.vue'),
      meta: {
        title: t('userManagement.userInfo'),
        hideBreadcrumb: true,
        hideMenu: true
      }
    }
  ]
}

export default UserManagerRoute
